import {
  GET_TASKS_CRMIT_LIST,
  GET_TASKS_CRMIT_LIST_SUCCESS,
  GET_TASKS_CRMIT_LIST_ERROR,
  CREATE_TASK_CRMIT,
  CREATE_TASK_CRMIT_SUCCESS,
  CREATE_TASK_CRMIT_ERROR,
  GET_TASK_CRMIT,
  GET_TASK_CRMIT_SUCCESS,
  GET_TASK_CRMIT_ERROR,
  UPDATE_TASK_CRMIT,
  UPDATE_TASK_CRMIT_SUCCESS,
  UPDATE_TASK_CRMIT_ERROR,
  CLAIM_TASK_CRMIT,
  CLAIM_TASK_CRMIT_SUCCESS,
  CLAIM_TASK_CRMIT_ERROR,
  DELETE_TASK_CRMIT,
  DELETE_TASK_CRMIT_SUCCESS,
  DELETE_TASK_CRMIT_ERROR,
  GET_TASK_STATUS_LIST_CRMIT,
  GET_TASK_STATUS_LIST_CRMIT_SUCCESS,
  GET_TASK_STATUS_LIST_CRMIT_ERROR,
  SEARCH_TASK_LIST,
  SEARCH_TASK_LIST_SUCCESS,
  SEARCH_TASK_LIST_ERROR,
  GET_TASK_TYPE_LIST,
  GET_TASK_TYPE_LIST_SUCCESS,
  GET_TASK_TYPE_LIST_ERROR,
  GET_TASK_PRIORITY_LIST,
  GET_TASK_PRIORITY_LIST_SUCCESS,
  GET_TASK_PRIORITY_LIST_ERROR,
  GET_SINGLE_TASK_NOTE_DATA,
  GET_SINGLE_TASK_NOTE_DATA_SUCCESS,
  GET_SINGLE_TASK_NOTE_DATA_ERROR,
  CREATE_SINGLE_TASK_NOTE,
  CREATE_SINGLE_TASK_NOTE_SUCCESS,
  CREATE_SINGLE_TASK_NOTE_ERROR,
  SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER,
  SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER_SUCCESS,
  SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER_ERROR,
  SEARCH_TASK_TIME_ENTRY_LIST,
  SEARCH_TASK_TIME_ENTRY_LIST_SUCCESS,
  SEARCH_TASK_TIME_ENTRY_LIST_ERROR,
  CREATE_TASK_TIME_ENTRY,
  CREATE_TASK_TIME_ENTRY_SUCCESS,
  CREATE_TASK_TIME_ENTRY_ERROR,
  ADD_NEW_TASK_STATUS,
  ADD_NEW_TASK_STATUS_SUCCESS,
  ADD_NEW_TASK_STATUS_ERROR,
  UPDATE_TASK_STATUS,
  UPDATE_TASK_STATUS_SUCCESS,
  UPDATE_TASK_STATUS_ERROR,
  DELETE_TASK_STATUS,
  DELETE_TASK_STATUS_SUCCESS,
  DELETE_TASK_STATUS_ERROR,
  ADD_NEW_TASK_TYPE,
  ADD_NEW_TASK_TYPE_SUCCESS,
  ADD_NEW_TASK_TYPE_ERROR,
  UPDATE_TASK_TYPE,
  UPDATE_TASK_TYPE_SUCCESS,
  UPDATE_TASK_TYPE_ERROR,
  DELETE_TASK_TYPE,
  DELETE_TASK_TYPE_SUCCESS,
  DELETE_TASK_TYPE_ERROR,
  ADD_NEW_TASK_PRIORITY,
  ADD_NEW_TASK_PRIORITY_SUCCESS,
  ADD_NEW_TASK_PRIORITY_ERROR,
  UPDATE_TASK_PRIORITY,
  UPDATE_TASK_PRIORITY_SUCCESS,
  UPDATE_TASK_PRIORITY_ERROR,
  DELETE_TASK_PRIORITY,
  DELETE_TASK_PRIORITY_SUCCESS,
  DELETE_TASK_PRIORITY_ERROR,
  GET_TASK_RECENT_ACTIVITY_LIST,
  GET_TASK_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_TASK_RECENT_ACTIVITY_LIST_ERROR,
  GET_TASK_CHANGE_LOG_LIST,
  GET_TASK_CHANGE_LOG_LIST_SUCCESS,
  GET_TASK_CHANGE_LOG_LIST_ERROR,
  GET_TASK_TEMPLATE_LIST,
  GET_TASK_TEMPLATE_LIST_SUCCESS,
  GET_TASK_TEMPLATE_LIST_ERROR,
  GET_TASK_TEMPLATE_DATA,
  GET_TASK_TEMPLATE_DATA_SUCCESS,
  GET_TASK_TEMPLATE_DATA_ERROR,
  CREATE_TASK_TEMPLATE,
  CREATE_TASK_TEMPLATE_SUCCESS,
  CREATE_TASK_TEMPLATE_ERROR,
  UPDATE_TASK_TEMPLATE,
  UPDATE_TASK_TEMPLATE_SUCCESS,
  UPDATE_TASK_TEMPLATE_ERROR,
  DELETE_TASK_TEMPLATE,
  DELETE_TASK_TEMPLATE_SUCCESS,
  DELETE_TASK_TEMPLATE_ERROR,
  SEARCH_TASK_TEMPLATE_LIST,
  SEARCH_TASK_TEMPLATE_LIST_SUCCESS,
  SEARCH_TASK_TEMPLATE_LIST_ERROR,
  GET_TASK_ATTACHMENT_LIST,
  GET_TASK_ATTACHMENT_LIST_SUCCESS,
  GET_TASK_ATTACHMENT_LIST_ERROR,
  SEARCH_TASK_ATTACHMENT_LIST,
  SEARCH_TASK_ATTACHMENT_LIST_SUCCESS,
  SEARCH_TASK_ATTACHMENT_LIST_ERROR,
  GET_TASK_ATTACHMENT_DATA,
  GET_TASK_ATTACHMENT_DATA_SUCCESS,
  GET_TASK_ATTACHMENT_DATA_ERROR,
  DELETE_TASK_ATTACHMENT,
  DELETE_TASK_ATTACHMENT_SUCCESS,
  DELETE_TASK_ATTACHMENT_ERROR,
  TASK_USE_HEART_BEAT_LOCALLY,
  TASK_USE_HEART_BEAT_LOCALLY_SUCCESS,
  TASK_USE_HEART_BEAT_LOCALLY_ERROR,
} from "./actionType";

const INIT_STATE = {
  tasksCrmITList: [],
  tasksCrmITListError: null,
  taskCrmIT: null,
  taskCrmITLoading: false,
  taskCrmITError: null,
  taskStatusListCrmIT: [],
  singleCustomerTaskList: [],
  searchTaskList: [],
  taskTypeList: [],
  taskPriorityList: [],
  singleTaskNoteData: [],
  taskCreateSuccess: [],
  taskCreateSuccessLoading: false,
  taskUpdateSuccess: [],
  taskUpdateSuccessLoading: false,
  deleteTaskSuccess: [],
  tasksCrmITListApiLoaded: false,
  singleJobTasksListForTimer: [],
  singleJobTasksListForTimerLoading: false,
  addNewTaskStatusSuccess: [],
  updateTaskStatusSuccess: [],
  deleteTaskStatusSuccess: [],
  addNewTaskTypeSuccess: [],
  updateTaskTypeSuccess: [],
  deleteTaskTypeSuccess: [],
  addNewTaskPrioritySuccess: [],
  updateTaskPrioritySuccess: [],
  deleteTaskPrioritySuccess: [],
  singleTaskRecentActivityList: [],
  singleTaskRecentActivityListLoading: false,
  singleTaskChangeLogList: [],
  singleTaskChangeLogListLoading: false,
  singleTaskNoteCreatedSuccess: [],
  singleTaskNoteCreatedError: [],

  //Template
  taskTemplateList: [],
  taskTemplateListError: null,
  taskTemplateData: [],
  taskTemplateDataLoading: false,
  taskTemplateDataError: null,
  taskTemplateCreateSuccess: [],
  taskTemplateCreateSuccessLoading: false,
  taskTemplateUpdateSuccess: [],
  taskTemplateUpdateSuccessLoading: false,
  deleteTaskTemplateSuccess: [],
  deleteTaskTemplateError: null,
  deleteTaskTemplateLoading: false,
  taskTemplateSearchList: [],
  taskTemplateSearchListError: null,
  taskTemplateSearchListLoading: false,
  //attachment
  taskAttachmentList: [],
  taskAttachmentListLoading: false,
  taskAttachmentListError: null,
  taskAttachmentSearchList: [],
  taskAttachmentSearchListLoading: false,
  taskAttachmentSearchListError: null,
  taskAttachmentData: [],
  taskAttachmentDataLoading: false,
  taskAttachmentDataError: null,
  deleteTaskAttachmentSuccess: [],
  deleteTaskAttachmentLoading: false,
  deleteTaskAttachmentError: null,
  // Heart Beat
  taskUseHeartbeat: false,
  taskUseHeartbeatLoading: false,
  taskUseHeartbeatError: null,
};

const TasksCrmIt = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TASKS_CRMIT_LIST:
      return { ...state, tasksCrmITListLoading: true };

    case GET_TASKS_CRMIT_LIST_SUCCESS:
      return {
        ...state,
        tasksCrmITList: action.payload,
        tasksCrmITListLoading: false,
      };

    case GET_TASKS_CRMIT_LIST_ERROR:
      return {
        ...state,
        tasksCrmITListError: action.payload,
        tasksCrmITListLoading: false,
      };

    case CREATE_TASK_CRMIT:
      return { ...state, taskCreateSuccessLoading: true };

    case CREATE_TASK_CRMIT_SUCCESS:
      return {
        ...state,
        taskCreateSuccess: action.payload,
        taskCreateSuccessLoading: false,
      };

    case CREATE_TASK_CRMIT_ERROR:
      return {
        ...state,
        taskCreateSuccess: action.payload,
        taskCreateSuccessLoading: false,
      };

    case GET_TASK_CRMIT:
      return { ...state, taskCrmITLoading: true };

    case GET_TASK_CRMIT_SUCCESS:
      return { ...state, taskCrmIT: action.payload, taskCrmITLoading: false };

    // Clearing the flag here matters: the overlay used to key off an empty
    // task, so a failed fetch left it spinning forever.
    case GET_TASK_CRMIT_ERROR:
      return {
        ...state,
        taskCrmITError: action.payload,
        taskCrmITLoading: false,
      };

    case UPDATE_TASK_CRMIT:
      return { ...state, taskUpdateSuccessLoading: true };

    case UPDATE_TASK_CRMIT_SUCCESS:
      return {
        ...state,
        taskUpdateSuccess: action.payload,
        taskUpdateSuccessLoading: false,
      };

    case UPDATE_TASK_CRMIT_ERROR:
      return {
        ...state,
        taskCrmITError: action.payload,
        taskUpdateSuccessLoading: false,
      };

    case CLAIM_TASK_CRMIT:
      return { ...state, taskClaimSuccessLoading: true };

    case CLAIM_TASK_CRMIT_SUCCESS:
      return {
        ...state,
        taskClaimSuccess: action.payload,
        taskClaimSuccessLoading: false,
      };

    case CLAIM_TASK_CRMIT_ERROR:
      return {
        ...state,
        taskCrmITError: action.payload,
        taskClaimSuccessLoading: false,
      };

    case DELETE_TASK_CRMIT:
      return { ...state };

    case DELETE_TASK_CRMIT_SUCCESS:
      return { ...state, deleteTaskSuccess: action.payload };

    case DELETE_TASK_CRMIT_ERROR:
      return { ...state, taskCrmITError: action.payload };

    case GET_TASK_STATUS_LIST_CRMIT:
      return { ...state };

    case GET_TASK_STATUS_LIST_CRMIT_SUCCESS:
      return { ...state, taskStatusListCrmIT: action.payload };

    case GET_TASK_STATUS_LIST_CRMIT_ERROR:
      return { ...state, taskStatusListCrmITError: action.payload };

    case SEARCH_TASK_LIST:
      return { ...state, tasksCrmITListApiLoaded: true };

    case SEARCH_TASK_LIST_SUCCESS:
      return {
        ...state,
        searchTaskList: action.payload,
        tasksCrmITListApiLoaded: false,
      };

    case SEARCH_TASK_LIST_ERROR:
      return {
        ...state,
        searchTaskListError: action.payload,
        tasksCrmITListApiLoaded: false,
        singleTaskNoteCreatedSuccess: [],
      };

    case GET_TASK_TYPE_LIST:
      return { ...state };

    case GET_TASK_TYPE_LIST_SUCCESS:
      return { ...state, taskTypeList: action.payload };

    case GET_TASK_TYPE_LIST_ERROR:
      return { ...state, taskTypeListError: action.payload };

    case GET_TASK_PRIORITY_LIST:
      return { ...state };

    case GET_TASK_PRIORITY_LIST_SUCCESS:
      return { ...state, taskPriorityList: action.payload };

    case GET_TASK_PRIORITY_LIST_ERROR:
      return { ...state, taskPriorityListError: action.payload };

    case GET_SINGLE_TASK_NOTE_DATA:
      return { ...state };

    case GET_SINGLE_TASK_NOTE_DATA_SUCCESS:
      return { ...state, singleTaskNoteData: action.payload };

    case GET_SINGLE_TASK_NOTE_DATA_ERROR:
      return { ...state, singleTaskNoteDataError: action.payload };

    case CREATE_SINGLE_TASK_NOTE:
      return { ...state };

    case CREATE_SINGLE_TASK_NOTE_SUCCESS:
      return { ...state, singleTaskNoteCreatedSuccess: action.payload };

    case CREATE_SINGLE_TASK_NOTE_ERROR:
      return { ...state, singleTaskNoteCreatedError: action.payload };

    case SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER:
      return { ...state, singleJobTasksListForTimerLoading: true };

    case SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER_SUCCESS:
      return {
        ...state,
        singleJobTasksListForTimer: action.payload,
        singleJobTasksListForTimerLoading: false,
      };

    case SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER_ERROR:
      return {
        ...state,
        singleJobTasksListForTimer: action.payload,
        singleJobTasksListForTimerLoading: false,
      };

    case SEARCH_TASK_TIME_ENTRY_LIST:
      return { ...state, taskTimeEntryListLoading: true };

    case SEARCH_TASK_TIME_ENTRY_LIST_SUCCESS:
      return {
        ...state,
        taskTimeEntryList: action.payload,
        taskTimeEntryListLoading: false,
      };

    case SEARCH_TASK_TIME_ENTRY_LIST_ERROR:
      return {
        ...state,
        taskTimeEntryList: action.payload,
        taskTimeEntryListLoading: false,
      };

    case CREATE_TASK_TIME_ENTRY:
      return { ...state, taskTimeEntryCreateLoading: true };

    case CREATE_TASK_TIME_ENTRY_SUCCESS:
      return {
        ...state,
        taskTimeEntryCreateSuccess: action.payload,
        taskTimeEntryCreateLoading: false,
      };

    case CREATE_TASK_TIME_ENTRY_ERROR:
      return {
        ...state,
        taskTimeEntryCreateSuccess: action.payload,
        taskTimeEntryCreateLoading: false,
      };

    case ADD_NEW_TASK_STATUS:
      return { ...state };

    case ADD_NEW_TASK_STATUS_SUCCESS:
      return { ...state, addNewTaskStatusSuccess: action.payload };

    case ADD_NEW_TASK_STATUS_ERROR:
      return { ...state, addNewTaskStatusSuccess: action.payload };

    case UPDATE_TASK_STATUS:
      return { ...state };

    case UPDATE_TASK_STATUS_SUCCESS:
      return { ...state, updateTaskStatusSuccess: action.payload };

    case UPDATE_TASK_STATUS_ERROR:
      return { ...state, updateTaskStatusSuccess: action.payload };

    case DELETE_TASK_STATUS:
      return { ...state };

    case DELETE_TASK_STATUS_SUCCESS:
      return { ...state, deleteTaskStatusSuccess: action.payload };

    case DELETE_TASK_STATUS_ERROR:
      return { ...state, deleteTaskStatusSuccess: action.payload };

    case ADD_NEW_TASK_TYPE:
      return { ...state };

    case ADD_NEW_TASK_TYPE_SUCCESS:
      return { ...state, addNewTaskTypeSuccess: action.payload };

    case ADD_NEW_TASK_TYPE_ERROR:
      return { ...state, addNewTaskTypeSuccess: action.payload };

    case UPDATE_TASK_TYPE:
      return { ...state };

    case UPDATE_TASK_TYPE_SUCCESS:
      return { ...state, updateTaskTypeSuccess: action.payload };

    case UPDATE_TASK_TYPE_ERROR:
      return { ...state, updateTaskTypeSuccess: action.payload };

    case DELETE_TASK_TYPE:
      return { ...state };

    case DELETE_TASK_TYPE_SUCCESS:
      return { ...state, deleteTaskTypeSuccess: action.payload };

    case DELETE_TASK_TYPE_ERROR:
      return { ...state, deleteTaskTypeSuccess: action.payload };

    case ADD_NEW_TASK_PRIORITY:
      return { ...state };

    case ADD_NEW_TASK_PRIORITY_SUCCESS:
      return { ...state, addNewTaskPrioritySuccess: action.payload };

    case ADD_NEW_TASK_PRIORITY_ERROR:
      return { ...state, addNewTaskPrioritySuccess: action.payload };

    case UPDATE_TASK_PRIORITY:
      return { ...state };

    case UPDATE_TASK_PRIORITY_SUCCESS:
      return { ...state, updateTaskPrioritySuccess: action.payload };

    case UPDATE_TASK_PRIORITY_ERROR:
      return { ...state, updateTaskPrioritySuccess: action.payload };

    case DELETE_TASK_PRIORITY:
      return { ...state };

    case DELETE_TASK_PRIORITY_SUCCESS:
      return { ...state, deleteTaskPrioritySuccess: action.payload };

    case DELETE_TASK_PRIORITY_ERROR:
      return { ...state, deleteTaskPrioritySuccess: action.payload };

    case GET_TASK_RECENT_ACTIVITY_LIST:
      return { ...state, singleTaskRecentActivityListLoading: true };

    case GET_TASK_RECENT_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        singleTaskRecentActivityList: action.payload,
        singleTaskRecentActivityListLoading: false,
      };

    case GET_TASK_RECENT_ACTIVITY_LIST_ERROR:
      return {
        ...state,
        singleTaskRecentActivityListError: action.payload,
        singleTaskRecentActivityListLoading: false,
      };

    case GET_TASK_CHANGE_LOG_LIST:
      return { ...state, singleTaskChangeLogListLoading: true };

    case GET_TASK_CHANGE_LOG_LIST_SUCCESS:
      return {
        ...state,
        singleTaskChangeLogList: action.payload,
        singleTaskChangeLogListLoading: false,
      };

    case GET_TASK_CHANGE_LOG_LIST_ERROR:
      return {
        ...state,
        singleTaskChangeLogListError: action.payload,
        singleTaskChangeLogListLoading: false,
      };
    case GET_TASK_TEMPLATE_LIST:
      return { ...state };

    case GET_TASK_TEMPLATE_LIST_SUCCESS:
      return { ...state, taskTemplateList: action.payload };

    case GET_TASK_TEMPLATE_LIST_ERROR:
      return { ...state, taskTemplateListError: action.payload };

    case GET_TASK_TEMPLATE_DATA:
      return { ...state, taskTemplateDataLoading: true };

    case GET_TASK_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        taskTemplateDataLoading: false,
        taskTemplateData: action.payload,
      };

    case GET_TASK_TEMPLATE_DATA_ERROR:
      return {
        ...state,
        taskTemplateDataLoading: false,
        taskTemplateDataError: action.payload,
      };

    case CREATE_TASK_TEMPLATE:
      return { ...state, taskTemplateCreateSuccessLoading: true };

    case CREATE_TASK_TEMPLATE_SUCCESS:
      return {
        ...state,
        taskTemplateCreateSuccess: action.payload,
        taskTemplateCreateSuccessLoading: false,
      };

    case CREATE_TASK_TEMPLATE_ERROR:
      return {
        ...state,
        taskTemplateCreateSuccess: action.payload,
        taskTemplateCreateSuccessLoading: false,
      };

    case UPDATE_TASK_TEMPLATE:
      return { ...state, taskTemplateUpdateSuccessLoading: true };

    case UPDATE_TASK_TEMPLATE_SUCCESS:
      return {
        ...state,
        taskTemplateUpdateSuccess: action.payload,
        taskTemplateUpdateSuccessLoading: false,
      };

    case UPDATE_TASK_TEMPLATE_ERROR:
      return {
        ...state,
        taskTemplateUpdateSuccess: action.payload,
        taskTemplateUpdateSuccessLoading: false,
      };

    case DELETE_TASK_TEMPLATE:
      return { ...state, deleteTaskTemplateLoading: true };

    case DELETE_TASK_TEMPLATE_SUCCESS:
      return {
        ...state,
        deleteTaskTemplateSuccess: action.payload,
        deleteTaskTemplateLoading: false,
      };

    case DELETE_TASK_TEMPLATE_ERROR:
      return {
        ...state,
        deleteTaskTemplateError: action.payload,
        deleteTaskTemplateLoading: false,
      };

    case SEARCH_TASK_TEMPLATE_LIST:
      return { ...state, taskTemplateSearchListLoading: true };

    case SEARCH_TASK_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        taskTemplateSearchList: action.payload,
        taskTemplateSearchListLoading: false,
      };

    case SEARCH_TASK_TEMPLATE_LIST_ERROR:
      return {
        ...state,
        taskTemplateSearchListError: action.payload,
        taskTemplateSearchListLoading: false,
      };
    case GET_TASK_ATTACHMENT_LIST:
      return { ...state, taskAttachmentListLoading: true };

    case GET_TASK_ATTACHMENT_LIST_SUCCESS:
      return {
        ...state,
        taskAttachmentList: action.payload,
        taskAttachmentListLoading: false,
      };

    case GET_TASK_ATTACHMENT_LIST_ERROR:
      return {
        ...state,
        taskAttachmentListError: action.payload,
        taskAttachmentListLoading: false,
      };

    case SEARCH_TASK_ATTACHMENT_LIST:
      return { ...state, taskAttachmentSearchListLoading: true };

    case SEARCH_TASK_ATTACHMENT_LIST_SUCCESS:
      return {
        ...state,
        taskAttachmentSearchList: action.payload,
        taskAttachmentSearchListLoading: false,
      };

    case SEARCH_TASK_ATTACHMENT_LIST_ERROR:
      return {
        ...state,
        taskAttachmentSearchListError: action.payload,
        taskAttachmentSearchListLoading: false,
      };

    case GET_TASK_ATTACHMENT_DATA:
      return { ...state, taskAttachmentDataLoading: true };

    case GET_TASK_ATTACHMENT_DATA_SUCCESS:
      return {
        ...state,
        taskAttachmentData: action.payload,
        taskAttachmentDataLoading: false,
      };

    case GET_TASK_ATTACHMENT_DATA_ERROR:
      return {
        ...state,
        taskAttachmentDataError: action.payload,
        taskAttachmentDataLoading: false,
      };

    case DELETE_TASK_ATTACHMENT:
      return { ...state, deleteTaskAttachmentLoading: true };

    case DELETE_TASK_ATTACHMENT_SUCCESS:
      return {
        ...state,
        deleteTaskAttachmentSuccess: action.payload,
        deleteTaskAttachmentLoading: false,
      };

    case DELETE_TASK_ATTACHMENT_ERROR:
      return {
        ...state,
        deleteTaskAttachmentError: action.payload,
        deleteTaskAttachmentLoading: false,
      };
    case TASK_USE_HEART_BEAT_LOCALLY:
      return { ...state, taskUseHeartbeatLoading: true };

    case TASK_USE_HEART_BEAT_LOCALLY_SUCCESS:
      return {
        ...state,
        taskUseHeartbeat: action.payload,
        taskUseHeartbeatLoading: false,
      };

    case TASK_USE_HEART_BEAT_LOCALLY_ERROR:
      return {
        ...state,
        taskUseHeartbeatError: action.payload,
        taskUseHeartbeatLoading: false,
      };
    default:
      return { ...state };
  }
};
export default TasksCrmIt;
